export function modifiedResult(data) {
  let result = [];

  data.forEach(({ EVENT_SOURCE, API_OPERATION, API_STATUS, CREATED_DT }) => {
    let foundSource = result.find((item) => item.EVENT_SOURCE === EVENT_SOURCE);

    if (!foundSource) {
      foundSource = {
        EVENT_SOURCE,
        ERRORS_COUNT: 0,
        USERS_LOCKED: 0,
        USERS_UNLOCKED: 0,
        SKILLS_ASSIGNED: 0,
        SKILLS_UNASSIGNED: 0,
        CREATED_DT: CREATED_DT
          ? new Date(CREATED_DT).toLocaleDateString("en-US")
          : "",
      };
      result.push(foundSource);
    }

    if (API_STATUS === "ERROR") {
      foundSource.ERRORS_COUNT++;
    } else if (API_STATUS === "COMPLETE") {
      switch (API_OPERATION) {
        case "LOCK":
          foundSource.USERS_LOCKED++;
          break;
        case "UNLOCK":
          foundSource.USERS_UNLOCKED++;
          break;
        case "ASSIGN_SKILL":
          foundSource.SKILLS_ASSIGNED++;
          break;
        case "UNASSIGN_SKILL":
          foundSource.SKILLS_UNASSIGNED++;
          break;
        default:
          break;
      }
    }
  });

  return result;
}
